// extracted by mini-css-extract-plugin
module.exports = {"layout":"kHYqR___App-module__layout","header":"_1AU4e___App-module__header","breadcrumbsContainer":"z8NqA___App-module__breadcrumbsContainer"};